import { InputGroup, FormControl } from "react-bootstrap";
import { useLabels } from "../Label";

const ColumnFilter = ({ column: { filterValue, setFilter } }) => {
    const fLabel = useLabels()
    const placeholder = fLabel({ data: 'LabelSearch' });
    return (
        <InputGroup size="sm" className="mb-3 mt-3">
            <FormControl
                aria-label={fLabel({ data: "HeaderSmall" })}
                aria-describedby="inputGroup-sizing-sm"
                value={filterValue || ""}
                onChange={(e) => {
                    setFilter(e.target.value || undefined);
                }}
                placeholder={placeholder}
            />
        </InputGroup>
    );
};

export default ColumnFilter;
